import { ReportDefinition } from "../reporting.model";
import { DeliveryReport } from "./delivery/delivery.report";
import { HedgeCoverageReport } from "./hedging/hedge-coverage.report";
import { InventoryTransactionReport } from "./inventory/inventory-transactions.report";
import { ReportKey } from "./report-key.enum";

export { ReportKey };

export const REPORT_REGISTRY: Record<ReportKey, ReportDefinition> = {
    [ReportKey.Delivery]: DeliveryReport,
    [ReportKey.HedgeCoverage]: HedgeCoverageReport,
    [ReportKey.InventoryTransaction]: InventoryTransactionReport
};
